import type { UserLanguages } from 'generated/openapi';
import { z } from 'zod';

export const languagesSchema = z.object({
  speak: z
    .array(z.string().min(1))
    .min(1, { message: 'Pick at least one speech language' }),
  write: z
    .array(z.string().min(1))
    .min(1, { message: 'Pick at least one text language' }),
});

const DEFAULT_LANGUAGE = 'en';
/**
 * Gets the primary mutual language between two users.
 * Combines speak + write arrays, finds intersection, prioritizes non-English.
 *
 * @returns First mutual non-English language, or 'en' as fallback
 */
export function getMutualLanguage(
  languagesA: UserLanguages | undefined,
  languagesB: UserLanguages | undefined,
): string {
  const allA = new Set([
    ...(languagesA?.speak ?? []),
    ...(languagesA?.write ?? []),
  ]);

  const allB = new Set([
    ...(languagesB?.speak ?? []),
    ...(languagesB?.write ?? []),
  ]);

  const mutual = [...allA].filter(lang => allB.has(lang));
  const mutualNonEnglish = mutual.filter(lang => lang !== 'en');

  return mutualNonEnglish[0] ?? DEFAULT_LANGUAGE;
}
